import $ from "jquery";
import Slide from "./Slide";


export default class Top {
  constructor() {}

  init() {
    new Slide().init(() => {
      $("#js-title-wrapper-inner").removeClass("hidden");
      $("#js-images-wrapper").removeClass("hidden");
      $("#js-scroll-down").removeClass("hidden");
      $("#js-menu-wrapper").removeClass("hidden");
    });
  }
}



// WEBPACK FOOTER //
// ./src/js/modules/Top.js